// src/pages/Admin/VotePage/ui/VoteStatusPill.jsx

import React from "react";

const STATUS_CONFIGURATION = {
  actif: {
    label: "En cours",
    dot: "bg-emerald-500",
    classes:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20",
  },

  a_venir: {
    label: "À venir",
    dot: "bg-amber-500",
    classes:
      "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20",
  },

  termine: {
    label: "Terminé",
    dot: "bg-slate-400",
    classes:
      "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
  },

  inactif: {
    label: "Inactif",
    dot: "bg-rose-500",
    classes:
      "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20",
  },
};

export default function VoteStatusPill({ status }) {
  const configuration =
    STATUS_CONFIGURATION[status] ||
    STATUS_CONFIGURATION.inactif;

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-[11px] font-black ring-1 ${configuration.classes}`}
    >
      <span
        className={`h-2 w-2 rounded-full ${configuration.dot}`}
      />

      {configuration.label}
    </span>
  );
}